export type EventHandler<T> =
  | (() => void | Promise<void>)
  | ((data: T) => void | Promise<void>);

type UnsubscribeFn = () => void;

export default class EventEmitter<T> {
  private eventHandlers: Set<EventHandler<T>> = new Set();

  public subscribe(handler: EventHandler<T>): UnsubscribeFn {
    this.eventHandlers.add(handler);
    return () => this.eventHandlers.delete(handler);
  }

  public emit(data: T): void {
    this.eventHandlers.forEach((handler) => handler(data));
  }
}
